import { getOwner } from '@ember/application';

/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      lib util — resolves the app's `config:environment` registration
 *              from an owner-bearing context (component/service/route instance)
 *   extends:   -
 *   template:  none
 *   args:      -
 *   uses:      -
 *   siblings:  -
 *   tests:     get-config-test.js
 *
 * Thin wrapper over `getOwner(context).resolveRegistration('config:environment')`,
 * used wherever code outside a route/controller needs `config/environment.js`
 * (e.g. `APP.urlApi`).
 */
function getConfig(context) {
  return getOwner(context).resolveRegistration('config:environment');
}

export { getConfig as default };
//# sourceMappingURL=get-config.js.map
